/** Board 7's one big field, shared by the line and service popovers (moved from `quote/quote-editors.tsx` at step 8). */

/*
 * Board 7's one "big" field — the line's quantity, the service's measure: 44
 * tall at the control radius, the number 17/700 and the unit inside it. A
 * wrapper rather than an `EditorInput`, because the unit sits inside the
 * border and the focus ring belongs to the whole box.
 */
export const BIG_BOX = 'flex h-11 w-full items-center gap-1.5 rounded-control border border-line bg-surface'
  + ' px-[11px] focus-within:border-accent-line focus-within:ring-2 focus-within:ring-accent-ring'
export const BIG_INPUT = 'tnum min-w-0 flex-1 border-none bg-transparent p-0 text-left text-[17px]'
  + ' font-bold text-text focus:outline-none focus:ring-0'
